module.exports = __webpack_public_path__ + "img/puri_v.b0bd52cc.webp";